const viewInfo = [
  { key: 'home', icon: 'shouye2', activeIcon: 'shouye2', title: '首页', action: 'path:/' },
  {
    key: 'refund', icon: 'tuihuo2', activeIcon: 'tuihuo2', title: '退货',
    subs: [
      { key: 'refundBefore', icon: 'tuihuo2', activeIcon: 'tuihuo2', title: '原单退货' },
      { key: 'refundCurrent', icon: 'tuihuo2', activeIcon: 'tuihuo2', title: '非原单退货' }
    ]
  },
  // {key: 'sale', icon: 'tuihuo2', activeIcon: 'tuihuo2', title: '开单'},
  { key: 'list', icon: 'guadanxian1', activeIcon: 'guadanxian1', title: '挂单' },
  { key: 'list2', icon: 'guadanxian1', activeIcon: 'guadanxian1', title: '解挂' },
  {
    key: 'member', icon: 'huiyuanxian1', activeIcon: 'huiyuanxian1', title: '会员',
    subs: [
      { key: 'memberAdd', icon: 'chaxun1', activeIcon: 'chaxun1', title: '会员新增' },
      { key: 'memberManager', icon: 'chaxun1', activeIcon: 'chaxun1', title: '会员管理' }
    ]
  },
  {
    key: 'search', icon: 'chaxunxian1', activeIcon: 'chaxunxian1', title: '查询',
    subs: [
      { key: 'searchbill', icon: 'chaxun1', activeIcon: 'chaxun1', title: '单据查询' },
      { key: 'searchstock', icon: 'chaxun1', activeIcon: 'chaxun1', title: '库存查询' }
    ]
  },
  { key: 'online', icon: 'dianshangxuanzhong', activeIcon: 'dianshangxuanzhong', title: '电商', isTotal: true, totalNum: 0,subs:[] },
  { key: 'takeTheir', icon: 'zitimian', activeIcon: 'zitimian', title: '自提' },
  { key: 'delivery', icon: 'peisong-xuanzhong', activeIcon: 'peisong-xuanzhong', title: '配送', isTotal: true, totalNum: 0 },
  {key: 'cashbox', icon: 'danqianxiang', activeIcon: 'danqianxiang', title: '钱箱', className: 'cashbox-itemmm'},
  {key: 'lock', icon: 'suoping1', activeIcon: 'suoping1', title: '锁屏'},
  {key: 'quickKey', icon: 'suoping1', activeIcon: 'suoping1', title: '快捷键'},
  {key: 'more', icon: 'gengduo2', activeIcon: 'gengduo2', title: '更多'}
];
export default viewInfo;
